let cssRegistry = {};
export function registerCssSerializer(id, css) {
    cssRegistry[id] = css;
    return css;
}
export function getRegisteredCssSerializer(id = 'default') {
    return cssRegistry[id];
}
/**
 * Used to test CSS serializer registry
 */ export function resetCssSerializerRegistry() {
    cssRegistry = {};
}

//# sourceMappingURL=css.js.map